module.exports = __webpack_public_path__ + "static/gubretas2-63c9142e3793343487ad6590c3df7008.png";